export default __webpack_public_path__ + "static/media/risk-bars-moderate-dark.0399dc28.svg";